var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgDarkModeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM0.895874 12C0.895874 18.1326 5.86736 23.1041 12 23.1041C18.1326 23.1041 23.1041 18.1326 23.1041 12C23.1041 5.86736 18.1326 0.895874 12 0.895874C5.86736 0.895874 0.895874 5.86736 0.895874 12Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0597 0.0305052C15.2426 0.0385955 18.2919 1.30742 20.5369 3.55786C22.7818 5.8083 24.0385 8.856 24.0304 12.0305C24.0224 15.205 22.7502 18.2463 20.4939 20.4853C18.2375 22.7243 15.1818 23.9776 11.9989 23.9695L12.0293 12L12.0597 0.0305052Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.053 23.1237C9.07767 23.1227 6.22462 21.949 4.12144 19.8607C2.01826 17.7724 0.837232 14.9406 0.838167 11.9882C0.839101 9.03585 2.02192 6.20478 4.12642 4.11781C6.23093 2.03084 9.08472 0.858925 12.06 0.859866L12.0565 11.9918L12.053 23.1237Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkModeIcon);
export default __webpack_public_path__ + "static/media/darkModeIcon.35bced4381c2d8d78e7d740e927ca5f9.svg";
export { ForwardRef as ReactComponent };